import styled from 'styled-components'

import PDPDivider from 'shared/components/PDPDivider'
import { media } from 'shared/lib'

import { EXPERIMENT_NAME } from 'experiments/constants/Experiments'
import { useLogExperiment } from 'experiments/hooks/useLogExperiment'
import { useStartExperiment } from 'experiments/hooks/useStartExperiment'
import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'
import { t } from 'localization'
import { useProductTemplateContext } from 'productTemplate/components/ProductTemplateContextProvider'
import Spinner from 'shared/components/Spinner'
import { useShoppingRegionContext } from 'shared/contexts/ShoppingRegionContextProvider'
import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { RafflePdpModule } from 'shared/components/Raffles/RafflePdpModule'
import ProductDescription from './ProductDescription'
import { ProductPicker } from './ProductPicker'
import { ShippingAndReturnsDropdown } from './ShippingAndReturnsDropdown'

const TP = 'productTemplate.components.ProductDetails'

const ProductDetailsBox = styled.div`
  max-width: 430px;
  width: 100%;
  margin: 10px 0;
`
const PositionedDividerMobileOnly = styled(PDPDivider)`
  position: absolute;
  left: 0;
  width: 100vw;
  ${media.large`
    display: none;
  `}
`
const PositionedDivider = styled(PDPDivider)`
  position: absolute;
  left: 0;
  width: 100%;
  ${media.large`
    position: relative;
  `}
`

const ProductDetails = () => {
  const allInclusivePricingExperiment: EXPERIMENT_NAME = 'web_fc_all_inclusive_pricing_v2'
  const enableExperiments = useFeatureFlag(FeatureFlag.WEB_FC_ENABLE_EXPERIMENTS)
  const enableAllInclusivePricingCopyExperiment = useFeatureFlag(
    FeatureFlag.TEMP_WEB_FC_ENABLE_ALL_INCLUSIVE_PRICING_COPY_EXPERIMENT,
  )
  const { productTemplate, loadingPricing } = useProductTemplateContext()

  const { country } = useShoppingRegionContext()
  const isShoppingRegionUS = country === 'US'

  const { isAssigning: isExperimentLoading } = useStartExperiment(
    allInclusivePricingExperiment,
    !enableExperiments || !enableAllInclusivePricingCopyExperiment,
  )
  useLogExperiment(
    allInclusivePricingExperiment,
    !enableExperiments || !enableAllInclusivePricingCopyExperiment || !isShoppingRegionUS,
  )

  return (
    <ProductDetailsBox>
      <Spinner
        showSpinner={loadingPricing || isExperimentLoading}
        text={t(`${TP}.gettingLatestPrices`, 'Getting latest prices')}
      >
        <ProductPicker isLoading={loadingPricing || isExperimentLoading} />
      </Spinner>
      <RafflePdpModule productSlug={productTemplate.slug} />
      <PositionedDivider />
      <ProductDescription
        sku={productTemplate.sku}
        description={productTemplate.details}
        releaseDate={productTemplate.releaseDate.shortDisplay}
        storyHtml={productTemplate.storyHtml}
      />
      <PositionedDividerMobileOnly />
      <ShippingAndReturnsDropdown />
    </ProductDetailsBox>
  )
}

export default ProductDetails
